import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.img.attrs({ src: '/images/loading.png' })`
  animation: ${rotate} 2s infinite linear;
`;
